import React, { Fragment, useEffect, useState } from "react";
import { Card, Row, Col, Form, Tooltip, OverlayTrigger} from "react-bootstrap";
import { abpnClient } from "../../Services/AbpnClient";
import ActivateUser from "./Models/ActivateUser";
import { ApplicationPaths } from "../../Services/Auth/AuthConstants";
import { Link } from "react-router-dom";

interface IProps {
    runValidation: boolean;
    isEmailFormValid: boolean;
    userModel: ActivateUser;
    updatePersonalEmail: (email: string) => void;
    updateEmailValidation: (isFormValid: boolean) => void;
}

export function PersonalEmailCard(props: IProps) {
    const [isNewEmailUnique, setIsNewEmailUnique] = useState<boolean>(null);
    const [isFormatValid, setIsFormatValid] = useState<boolean>(true);

    var encodedLoginUrl = encodeURIComponent(ApplicationPaths.DefaultLoginRedirectPath);

    let validFormatAndNotUniqueEmail = (isFormatValid === true && isNewEmailUnique === false);

    useEffect(() => {
        if (props.runValidation) validate();
    }, [props.runValidation]);

    const validate = async () => {
        const form = document.getElementById("personalEmail") as HTMLFormElement;
        var isEmailValid = form.checkValidity();
        setIsFormatValid(isEmailValid);

        if (isEmailValid) {
            await abpnClient.post<boolean>('/api/profile/validateEmail', props.userModel, null)
            .then((response: boolean) => {
                setIsNewEmailUnique(response);
                isEmailValid = response;
            });
        }
       props.updateEmailValidation(isEmailValid);
    }

    return (
        <Fragment>
            <Card className="mb-4" border="pp-secondary-grey">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-pp-primary">Security</span>
                    </Card.Title>
                    <Row className="mt-3">
                        <Col xs={12} md={12} lg={12} xl={12}>
                            <Form noValidate validated={props.runValidation && !validFormatAndNotUniqueEmail}>
                                <Row noGutters className="align-items-end">
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="personalEmail">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">
                                                Personal Email Address
                                                <span className="text-pp-primary ml-2">*</span>
                                                <OverlayTrigger
                                                    placement={"right"}
                                                    overlay={<Tooltip id="email" bsPrefix="pp-tooltip">
                                                        ABPN highly recommends keeping a personal email address on file to ensure
                                                        you receive all communications regarding applications, exams,
                                                        certification requirements, pertinent updates, and to access your ABPN
                                                        Physician Portal account.
                                                        This will be used to log into the Physician Portal.
                                                    </Tooltip>}>
                                                    <i className="las la-info-circle ml-1 la-lg"></i>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Form.Control type="email" required onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {props.updatePersonalEmail(e.target.value)}}></Form.Control>
                                            {props.isEmailFormValid === false && 
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid email address.
                                            </Form.Control.Feedback>
                                            }
                                            {isNewEmailUnique === false &&
                                            <p className='pp-font-size-smallest text-danger mt-2'>
                                                This email address is already associated with an account. If the account is yours, then 
                                                <Link to={`${ApplicationPaths.Login}/${props.userModel?.email}/${encodedLoginUrl}`}> Log In </Link> 
                                                using that email address, otherwise enter a different email address. 
                                            </p>
                                            }
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Fragment>
    );
}

export default PersonalEmailCard;
